import { render, staticRenderFns } from "./m-card-wide.vue?vue&type=template&id=7025ae6f&scoped=true&v-if=href"
import script from "./m-card-wide.vue?vue&type=script&lang=js"
export * from "./m-card-wide.vue?vue&type=script&lang=js"
import style0 from "./m-card-wide.vue?vue&type=style&index=0&id=7025ae6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7025ae6f",
  null
  
)

export default component.exports